module.exports = __webpack_public_path__ + "img/background_section5.7d0fafb6.svg";